export const data = {
  description:
    "Your strategic partner in the global supply chain, delivering professional, efficient, and reliable logistics and freight solutions.",
  address:
    "Address: Av. Balboa, Torre BAC, piso 13, oficina 2 Panamá, Panama City, Panama 0831",
  quick: "Quick Links",
  aboutUs: "About Us",
  services: "Services",
  contactUs: "Contact Us",

  maritimeLaw: "Maritime Law",
  taxLaw: "Tax Law",
  customsLaw: "Customs Law",
  commercialLaw: "Commercial Law",
  insurance: "Insurance",
  administrativeProcesses: "Administrative Processes",
  stsOperations: "STS Operations",

  community: "Community",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
};
